import { Box } from "@mui/system";
import styles from "./Breadcrumbs.module.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Breadcrumbs() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const taskTitle = queryParams.get("taskTitle");
  const tabTitle = queryParams.get("tabTitle");
  const pathname = location.pathname.split("/").filter((x: any) => x);
  const search = location.search; // Preserve query parameters

  // Safe decode wrapper
  const safeDecode = (value: string) => {
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  };

  const formatBreadcrumbName = (name: any) =>
    name
      .replace(/_/g, " ") // replace underscores with spaces
      .replace(/\b\w/g, (char: any) => char.toUpperCase());

  const breadcrumbs = ["", ...pathname];
  const currentPath = breadcrumbs.join("/");

  return (
    <div className={styles.breadcrumbs}>
      <div className={styles.icon}>
        <img className={styles.starfilledIcon} alt="" src="/starfilled8.svg" />
      </div>
      <div className={styles.link1}>
        {breadcrumbs.map((name, index) => {
          const isHome = index === 0;
          const isFirstAfterHome = index === 1;
          let breadcrumbPath = isHome
            ? ""
            : `${breadcrumbs.slice(1, index + 1).join("/")}`;
          let newBreadcrumbs = breadcrumbs.slice(1, index + 1).join("/");
          const isCurrent = breadcrumbPath === currentPath;
          const fullPath = `${breadcrumbPath}${search}`;

          if (newBreadcrumbs === "data_collection/unifier_maps") {
            name = "Unifier Maps";
          } else if (newBreadcrumbs === "admin/etl-sequences") {
            name = "ETL sequences";
          } else if (newBreadcrumbs === "performance/page_builder") {
            name = "Page Building";
          } else if (newBreadcrumbs === "performance/insights") {
            name = "Performance Insights";
          } else if (newBreadcrumbs === "admin/etl-process-list") {
            name = "ETL list";
          } else if (newBreadcrumbs === "admin/queries") {
            name = "Queries";
          } else if (newBreadcrumbs === "admin/etl-process-log") {
            name = "ETL log";
          } else if (
            newBreadcrumbs === "admin/etl-process-log/etl-process-log-Response"
          ) {
            name = "ETL log Response";
          } else if (newBreadcrumbs === "operations/page_speed_performance") {
            name = "Page Speed Performance";
          } else if (
            newBreadcrumbs === "operations/templates/create_new_template"
          ) {
            name = "Create new Template";
          } else if (newBreadcrumbs === "operations/theme/create_new_theme") {
            name = "Create new Theme";
          } else if (newBreadcrumbs === "operations/theme/edit_new_theme") {
            name = "Edit new Theme";
          } else if (
            newBreadcrumbs === "operations/templates/edit_new_template"
          ) {
            name = "Edit new Template";
          } else if (newBreadcrumbs === "tools/activity_notes") {
            name = "Activity Notes";
          } else if (newBreadcrumbs === "operations/deals_and_promotions") {
            name = "Deals & Promotions";
          } else if (newBreadcrumbs === "operations/data_accuracy") {
            name = "Data Accuracy";
          } else if (
            newBreadcrumbs === "operations/data_accuracy/FTDvsQFTD_NGPD"
          ) {
            name = "FTD vs. QFTD - NGPD";
          } else if (newBreadcrumbs === "operations/data_accuracy/task_name") {
            // ✅ Safe decoding applied here
            name = taskTitle ? safeDecode(taskTitle) : "Task Name";
          }

          name = formatBreadcrumbName(name);

          if (isHome && pathname.length === 1) {
            return (
              <Link
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent ? styles.breadcrumbCurrent : styles.breadcrumbLink
                }
                data-tracker="2"
              >
                {(name ? name : "Home").split(" ").join("  ")}
              </Link>
            );
          } else if (isHome) {
            return (
              <Link
                to={breadcrumbPath}
                key={breadcrumbPath}
                className={
                  isCurrent ? styles.breadcrumbCurrent : styles.breadcrumbLink
                }
                data-tracker="2"
              >
                {(name ? name : "Home").split(" ").join("  ")}
              </Link>
            );
          } else if (
            newBreadcrumbs === "operations/deals_and_promotions" &&
            tabTitle
          ) {
            return (
              <span key={breadcrumbPath} className={styles.breadcrumbSeparator}>
                <Box sx={{ padding: "0 8px" }}>/</Box>
                {name.split(" ").join("  ")}
              </span>
            );
          } else if (index === breadcrumbs.length - 1) {
            return (
              <span key={breadcrumbPath} className={styles.breadcrumbCurrent}>
                <Box sx={{ padding: "0 8px" }}>/</Box>
                {
                  //Safe decode applied here
                  safeDecode(name.split(" ").join("  "))
                }
              </span>
            );
          } else if (isFirstAfterHome) {
            return (
              <span
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
              >
                <Box sx={{ padding: "0 8px" }}>/</Box>{" "}
                {name.split(" ").join("  ")}
              </span>
            );
          } else if (newBreadcrumbs === "data_collection/unifier_maps") {
            const mapsPath = `${breadcrumbPath}${search}`;
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={mapsPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (
            newBreadcrumbs === "operations/brand_configuration_report"
          ) {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "operations/website_actions") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "operations/page_groups") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "operations/theme") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "operations/templates") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "operations/data_accuracy") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "/performance/search_term_operations") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "performance/insights") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "performance/manual_expenses") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "performance/landing_page_experience") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "business_leader/dashboard") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "business_leader/website_projection") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "business_leader/trends") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "business_leader/forecaster") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "admin/queries") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "tools/activity_notes") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "tools/action_items") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "data_collection/unique_definitions") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (newBreadcrumbs === "admin/etl-process-log") {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else if (index <= 2) {
            if (newBreadcrumbs === "assets/page_management") {
              return (
                <Link
                  style={{ textDecoration: "none" }}
                  to={fullPath}
                  key={breadcrumbPath}
                  className={
                    isCurrent
                      ? styles.breadcrumbCurrent
                      : styles.breadcrumbSeparator
                  }
                  data-tracker="2"
                >
                  <Box
                    sx={{
                      padding: "0 8px",
                      cursor: "default",
                      textDecoration: "none",
                    }}
                  >
                    /
                  </Box>{" "}
                  <Box sx={{ textDecoration: "underline" }}>
                    {name.split(" ").join("  ")}
                  </Box>
                </Link>
              );
            } else if (newBreadcrumbs === "performance/page_builder") {
              return (
                <Link
                  style={{ textDecoration: "none" }}
                  to={fullPath}
                  key={breadcrumbPath}
                  className={
                    isCurrent
                      ? styles.breadcrumbCurrent
                      : styles.breadcrumbSeparator
                  }
                  data-tracker="2"
                >
                  <Box
                    sx={{
                      padding: "0 8px",
                      cursor: "default",
                      textDecoration: "none",
                    }}
                  >
                    /
                  </Box>{" "}
                  <Box sx={{ textDecoration: "underline" }}>
                    {name.split(" ").join("  ")}
                  </Box>
                </Link>
              );
            } else if (newBreadcrumbs === "finance/receipts") {
              return (
                <Link
                  style={{ textDecoration: "none" }}
                  to={fullPath}
                  key={breadcrumbPath}
                  className={
                    isCurrent
                      ? styles.breadcrumbCurrent
                      : styles.breadcrumbSeparator
                  }
                  data-tracker="2"
                >
                  <Box sx={{ padding: "0 8px", cursor: "default" }}>/</Box>{" "}
                  <Box sx={{ textDecoration: "underline" }}>
                    {name.split(" ").join("  ")}
                  </Box>
                </Link>
              );
            } else {
              return (
                <span
                  style={{ textDecoration: "none" }}
                  key={breadcrumbPath}
                  className={
                    isCurrent
                      ? styles.breadcrumbCurrent
                      : styles.breadcrumbSeparator
                  }
                >
                  <Box
                    sx={{
                      padding: "0 8px",
                      cursor: "default",
                      textDecoration: "none",
                    }}
                  >
                    /
                  </Box>{" "}
                  {name.split(" ").join("  ")}
                </span>
              );
            }
          } else if (index <= 3) {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={
                  isCurrent
                    ? styles.breadcrumbCurrent
                    : styles.breadcrumbSeparator
                }
                data-tracker="2"
              >
                <Box
                  sx={{
                    padding: "0 8px",
                    cursor: "default",
                    textDecoration: "none",
                  }}
                >
                  /
                </Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          } else {
            return (
              <Link
                style={{ textDecoration: "none" }}
                to={fullPath}
                key={breadcrumbPath}
                className={styles.breadcrumbSeparator}
                data-tracker="2"
              >
                <Box
                  sx={{
                    padding: "0 8px",
                    cursor: "default",
                    textDecoration: "none",
                  }}
                  data-tracker="2"
                >
                  /
                </Box>{" "}
                <Box sx={{ textDecoration: "underline" }}>
                  {name.split(" ").join("  ")}
                </Box>
              </Link>
            );
          }
        })}
        {tabTitle && pathname.join("/") === "operations/deals_and_promotions" && (
          <span className={styles.breadcrumbCurrent}>
            <Box sx={{ padding: "0 8px" }}>/</Box>
            {tabTitle.split(" ").join("  ")}
          </span>
        )}
      </div>
    </div>
  );
}
